
import { css } from 'lit';
export default css`
@media (min-width: 1024px) {:host {
    padding-bottom: 600px;
    display: block
}
  }

.mlp-hero__wrapper {
    display: grid;
    grid-template-columns: 0.5fr 90vw 0.5fr;
    grid-template-rows: 1fr 20vw auto;
    gap: 0px 0px;
    color: white;
    /* full-bleed */
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    margin-bottom: 10px;
}

@media (min-width: 768px) {

.mlp-hero__wrapper {
    grid-template-columns: 0.5fr 604px 0.5fr
}
  }

@media (min-width: 1024px) {

.mlp-hero__wrapper {
    display: grid;
    grid-template-columns: 1fr 430px 430px 1fr;
    grid-template-rows: 5em 1fr 3em;
    gap: 0px 0px;
    grid-auto-flow: row;
    max-height: 610px;
    margin: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    position: absolute
}
  }

.mlp-hero__content_wrapper {
    grid-area: 2 / 2 / 4 / 3;
    z-index: 2;
    position: relative;
    overflow: hidden;
    padding: 2.875em 1.75em 6.2em 1.75em;
}

@media (min-width: 1024px) {

.mlp-hero__content_wrapper {
    margin-left: 6rem
}
  }

@media (min-width: 1200px) {

.mlp-hero__content_wrapper {
    margin-left: 0
}
  }

@media screen and (min-width: 1024px) {
    .mlp-hero__content_wrapper {
        grid-area: 2 / 1 / 3 / 3;
        padding: 4.7em 4em 7em 4em;
    }
}

.mlp-hero__content_background {
    grid-area: 2 / 2 / 4 / 3;
    background-color: rgba(107, 31, 153, 1);
    z-index: 1;
}

@media (min-width: 1024px) {

.mlp-hero__content_background {
    margin-left: 6rem
}
  }

@media (min-width: 1200px) {

.mlp-hero__content_background {
    margin-left: 0
}
  }

@media screen and (min-width: 1024px) {
    .mlp-hero__content_background {
        grid-area: 2 / 1 / 3 / 3;
    }
}

.mlp-hero__content {
    display: flex;
    flex-direction: column;
}

.mlp-hero__eyebrow {
  margin-bottom: 1em;
}

@media screen and (min-width: 1024px) {
  .mlp-hero__eyebrow {
      margin-bottom: 1.75em;
  }
}

.mlp-hero__title {
    margin-bottom: 1.25em;
}

@media screen and (min-width: 1024px) {
  .mlp-hero__title {
    margin-bottom: 0.4375em;
  }
}

.mlp-hero__text {
    margin-bottom: 1.5em;
}

.mlp-hero__icon {
    display: flex;
    position: absolute;
    bottom: -0.7em;
    height: 4em;
    fill: white;
    justify-content: end;
    right: 0;
}

@media (min-width: 1024px) {

.mlp-hero__icon {
    height: 7em
}
  }

.mlp-hero__media {
    grid-area: 1 / 1 / 3 / 4;
    position: relative;
}

.mlp-hero__media img {
    height: 358px;
    -o-object-fit: cover;
       object-fit: cover;
    width: 100%;
  }

@media (min-width: 1024px) {

.mlp-hero__media img {
      -o-object-fit: cover;
         object-fit: cover;
      -o-object-position: center;
         object-position: center;
      width: 68vw;
      margin-left: 16rem;
      height: 600px;
      max-height: 600px
  }
    }

@media (min-width: 1200px) {

.mlp-hero__media img {
      margin-left: 13.5rem
  }
    }

@media (min-width: 1366px) {

.mlp-hero__media img {
      width: 72vw;
      margin-left: 8.25rem
  }
    }

@media screen and (min-width: 1024px) {
    .mlp-hero__media {
        grid-area: 1 / 2 / 4 / 5;
        overflow: hidden;
    }
}

.lyt-visually-hidden {
    clip: rect(0 0 0 0);
    -webkit-clip-path: inset(50%);
            clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

.lightbox__play {
  position: absolute;
  width: 75px;
  height: 55px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 21.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='YouTube_Icon' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 1024 721' enable-background='new 0 0 1024 721' xml:space='preserve'%3E%3Cpath id='Triangle' fill='%23FFFFFF' d='M407,493l276-143L407,206V493z'/%3E%3Cpath id='The_Sharpness' opacity='0.12' fill-rule='evenodd' clip-rule='evenodd' d='M407,206l242,161.6l34-17.6L407,206z'/%3E%3Cg id='Lozenge'%3E%3Cg%3E%3Cpath fill='%23282928' d='M1013,156.3c0,0-10-70.4-40.6-101.4C933.6,14.2,890,14,870.1,11.6C727.1,1.3,512.7,1.3,512.7,1.3h-0.4 c0,0-214.4,0-357.4,10.3C135,14,91.4,14.2,52.6,54.9C22,85.9,12,156.3,12,156.3S1.8,238.9,1.8,321.6v77.5 C1.8,481.8,12,564.4,12,564.4s10,70.4,40.6,101.4c38.9,40.7,89.9,39.4,112.6,43.7c81.7,7.8,347.3,10.3,347.3,10.3 s214.6-0.3,357.6-10.7c20-2.4,63.5-2.6,102.3-43.3c30.6-31,40.6-101.4,40.6-101.4s10.2-82.7,10.2-165.3v-77.5 C1023.2,238.9,1013,156.3,1013,156.3z M407,493l0-287l276,144L407,493z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
  background-size: contain;
  background-repeat: no-repeat;
}

.lightbox__preview {
  width: 100%;
  height: 358px;
}
`;